import React from 'react';
import { RAIL_TYPES } from './navData';
import TypeIcon from './TypeIcon';
import TypeMenu from './TypeMenu';
import useCategoryHover from './useCategoryHover';
import './HeaderCategories.css';

// The side rail's category icons laid across the header, for every page except
// the homepage and checkout. Hovering an icon drops its
// menu down below the header; clicking goes to the category. Desktop only —
// hidden by CSS on mobile, where the hamburger menu covers the same categories.
const HeaderCategories = () => {
    const { openTypeId, close, iconProps, hoverZoneProps } = useCategoryHover();
    const openType = RAIL_TYPES.find((t) => t.id === openTypeId) || null;

    return (
        <div className="gh-headercats" {...hoverZoneProps}>
            <nav className="gh-headercats-row" aria-label="Browse by category">
                {RAIL_TYPES.map((t) => (
                    <button
                        key={t.id}
                        type="button"
                        className={`gh-headercats-btn${openTypeId === t.id ? ' active' : ''}`}
                        title={t.label}
                        aria-label={t.label}
                        {...iconProps(t)}
                    >
                        <TypeIcon type={t.id} />
                    </button>
                ))}
            </nav>

            {openType && (
                <TypeMenu type={openType} placement="header" onClose={close} />
            )}
        </div>
    );
};

export default HeaderCategories;
